import { createFileRoute } from '@tanstack/react-router';
import { CustomPickerScreen } from '@/features/allergens/CustomPickerScreen';
import { parsePicks, type PickSearch } from '@/features/allergens/lib/search';

/** The hand-picked matrix's picker. ?d=&r=&i= pre-ticks the current picks
 *  when the chef comes back from the matrix to change them. */
export const Route = createFileRoute('/_app/allergens/custom')({
  validateSearch: (s: Record<string, unknown>): PickSearch => parsePicks(s),
  component: CustomRoute,
});

function CustomRoute() {
  const picks = Route.useSearch();
  return <CustomPickerScreen initial={picks} />;
}
